import React from "react";
import Image from "react-bootstrap/esm/Image";
import { useNavigate } from "react-router-dom";

export default function CategoryList(props) {
  const { resetToHead, categories } = props;
  const navigate = useNavigate();

  return (
    <div className="bg-white p-2" style={{ overflowY: "auto", height: "100%" }}>
      {categories.map((c, index) => (
        <div
          key={c._id}
          className={`category-item d-flex align-items-center mb-2 p-2 ${
            index !== categories.length - 1 ? "border-bottom" : ""
          }`}
          onClick={() => {
            resetToHead();
            navigate(`/category/order?rootCategory=${c._id}`);
          }}
        >
          <Image
            className="small-category-image border border-info me-3"
            src={c.image}
            alt={c.name}
            fluid
            rounded
          />
          <div className="flex-grow-1 text-start">
            <h5 className="mb-1">{c.name}</h5>
            <span className="text-muted small-font">
              {c.products && c.products.length > 0
                ? `${c.products.length} ürün`
                : `${c.categories.length} kategori`}
            </span>
          </div>
        </div>
      ))}
      <style>
        {`
          .category-item {
            cursor: pointer;
            transition: background-color 0.3s ease, transform 0.2s ease;
            border-radius: 5px;
            background-color: #ffffff;
          }
          .category-item:hover {
            background-color: #e9f7fa; /* Soft light blue for hover */
            transform: scale(1.02);
          }
          .category-item:active {
            background-color: #d1ecf1; /* Slightly darker blue for active */
            transform: scale(1);
          }
          .category-item.border-bottom {
            border-bottom: 1px solid #dee2e6; /* Light gray line between items */
          }
          .small-category-image {
            width: 50px;
            height: auto;
          }
        `}
      </style>
    </div>
  );
}
